export function getPDPMicrodataJSONLD(page) {
  if (page.offers === undefined) {
    return {}
  }
  // Offers Section
  const priceValidUntil = '2021-12-31T23:59:59'
  // Our offers has different type liek PRINT, INTERNATIONAL, SINGLE_ISSUES and DIGITAL
  let offers = []
  const allSkus = []
  if (!page?.magazine) {
    return {}
  }
  page.offers &&
    Object.keys(page.offers).forEach(type => {
      // Get an array with all the offers with the spread operator
      offers = [
        ...offers,
        ...page.offers[type].map((offer, index) => {
          allSkus.push(offer.sku)
          return {
            '@type': 'Offer',
            name: offer.name || '',
            url: `https://www.magazine.co.uk${page.magazine.url}`,
            priceCurrency: 'GBP',
            price: offer.price || 0,
            priceValidUntil,
            itemCondition: 'https://schema.org/NewCondition',
            availability: 'https://schema.org/InStock',
            SKU: offer.sku,
            seller: {
              '@type': 'Organization',
              name: 'Magazine.co.uk',
              url: 'https://www.magazine.co.uk'
            }
          }
        })
      ]
    })
  // console.log('offers', offers)

  // Aggregate Rating
  // we have the ratings in percentage(0-100) not in stars (0-5)
  const aggregateRating =
    (page.magazine.rating &&
      page.magazine.rating.reviewCount && {
        '@type': 'AggregateRating',
        ratingValue: parseFloat(page.magazine.rating.ratingValue).toFixed(1) + '',
        bestRating: '5',
        worstRating: '1',
        ratingCount: page.magazine.rating.ratingCount ? page.magazine.rating.ratingCount + '' : '1',
        reviewCount: page.magazine.rating.reviewCount ? page.magazine.rating.reviewCount + '' : '1'
      }) ||
    undefined

  // Review
  const review =
    (page.magazine.rating &&
      page.magazine.rating.reviews &&
      page.magazine.rating.reviews.length > 0 &&
      page.magazine.rating.reviews.map(review => ({
        '@type': 'Review',
        reviewBody: review.details || '',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: review.vote_value + '',
          bestRating: '5',
          worstRating: '1'
        },
        author: {
          '@type': 'Person',
          name: review.nickname
        }
      }))) ||
    undefined

  // Main Section
  let category = 'Magazine Subscription'
  switch (page.magazine.type) {
    // TODO Add giftcard and e-giftcard
    case 'Magazine':
    default:
      category = 'Magazine Subscription'
  }

  console.log('allSkus=', allSkus)

  const jsonld = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: (page.magazine && page.magazine.title) || '',
    image: [`https://magazine.imgix.net${page.magazine.imageUrl}`],
    mainEntityOfPage: `https://www.magazine.co.uk${page.magazine.url}`,
    category,
    description: page.description || '',
    // sku: allSkus || '',
    gtin8: (page.magazine && page.magazine.ISSN) || '',
    brand: {
      '@type': 'Brand',
      name: (page.magazine && page.magazine.h1Title) || ''
    },
    offers
  }
  if (review) {
    if (aggregateRating) {
      jsonld.aggregateRating = aggregateRating
    }
    jsonld.review = review
  }
  // console.log('jsonld=', jsonld)
  return jsonld
}

export function getBreadcrumbsMicrodataJSONLD({ breadcrumbs }) {
  const itemListElement =
    breadcrumbs &&
    breadcrumbs.map((bc, index) => {
      if (!bc.last) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: bc.value,
          item: `${process.env.BASE_URL}${bc.url}`
        }
      } else {
        if (bc.name === null) {
          return
        }

        return {
          '@type': 'ListItem',
          position: index + 1,
          name: bc.value
        }
      }
    })

  const jsonld = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement
  }

  // console.log('getBreadcrumbsMicrodataJSONLD jsonld=', jsonld)
  return jsonld
}

export function getFAQMicrodataJSONLD(faqs) {
  const mainEntity = []

  // Create the FAQs in the JSON+LD format
  for (let i = 0; i < faqs.length; i++) {
    mainEntity.push({
      '@type': 'Question',
      name: faqs[i].question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faqs[i].answer
      }
    })
  }

  const payload = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity
  }

  console.log('getFAQMicrodataJSONLD payload=', payload)
  return payload
}
